import React, { createRef } from "react";
import { BillWatchLayout } from "../BillWatchLayout";
import { BillWatchEntities } from "../BillWatchEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { BillWatchProps } from "../BillWatchProps";
import { NSCCostChart } from "namirasoft-cost-react";
import RunDialogBox from "../components/RunDialogBox";

interface AWSViewPageProps extends NSARouterMakerResult, BillWatchProps { }

class AWSViewPage extends React.Component<AWSViewPageProps>
{
    BillWatchLayout_Ref = createRef<BillWatchLayout>();
    RunDialogBox_Ref = createRef<RunDialogBox>();

    override render()
    {
        return (
            <BillWatchLayout
                ref={this.BillWatchLayout_Ref}
                {...this.props}
                action={{
                    description: "You can view an AWS watch to see its general information, historical runs, anomalies, and payable amounts."
                }}
                pages={{
                    entity: BillWatchEntities.aws(this.props, (id) => this.RunDialogBox_Ref.current?.show(id)),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_history: [
                                            NSCCostChart.getTab(this.props)
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <RunDialogBox
					{...this.props}
                    ref={this.RunDialogBox_Ref}
					set_next_run={this.props.servers.bill_watch.aws.SetNextRun}
					reload={() => this.BillWatchLayout_Ref.current?.NSALayout_Ref.current?.NSASectionView_Ref.current?.reload()}
                />
            </BillWatchLayout>
        );
    }
}

export default AWSViewPage;